import styled from "styled-components";

/**
 * The measurement chips from the bowler's header.
 *
 * A chip is a label over a value that opens the picker for it -- the way this
 * application shows a number that can be corrected. It was written inside
 * BowlerHeader, so the scan review grew its own grid of dropdowns instead,
 * which is a different idea of the same thing and reads as a different
 * program.
 *
 * Moved here verbatim so both screens show a measurement the same way.
 */

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 67%;
  min-width: 0;

  @media only screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
    flex: 1 1 100%;
    margin-top: 4px;
  }

  @media (max-width: 767px) {
    flex: 1 1 100%;
    margin-top: 4px;
    justify-content: center;
  }
`;

export const ChipGroup = styled.div`
  display: inline-flex;
  align-items: stretch;
  gap: 4px;
  flex: 0 0 auto;
`;

/**
 * $alert marks a value the driller has to notice before working -- today
 * only left-handedness, which has been shown in red here for as long as the
 * product has existed.
 */
export const MetaChip = styled.button`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1px;
  padding: 4px 12px;
  border: 1px solid ${(props) => (props.$alert ? props.theme?.color?.error || "#D62828" : "#e5e7eb")};
  border-radius: 10px;
  background: #ffffff;
  text-align: left;
  cursor: ${(props) => (props.$readonly ? "default" : "pointer")};
  white-space: nowrap;
  flex: 0 0 auto;

  &:hover {
    background: ${(props) => (props.$readonly ? "#ffffff" : "#f5f6fa")};
  }
`;

export const ChipLabel = styled.span`
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #6b7280;
  text-transform: uppercase;
  line-height: 1.2;

  @media (max-width: 767px) {
    font-size: 8px;
  }
`;

export const ChipValue = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => (props.$alert ? props.theme?.color?.error || "#D62828" : "#00187e")};
  line-height: 1.2;

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;
